import React, { memo } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { fetchOrderDetails } from "ducks/actions";
import {
  makeSelectIsFetchingData,
  makeSelectGuestOrderOrderRef,
  makeSelectOrderDetails,
  makeSelectInProgressReplaceSim
} from "ducks/selectors";
import Spinner, { styles } from "components/Spinner";
import { ORDER_ACTION_TYPES } from "utils/constants";
import ReportFraud from "./ReportFraud";
import isEmpty from "lodash/isEmpty";

export const ReportFraudAction = props => {
  const {
    isFetchingOrderDetails,
    isSubmittingReplaceSim,
    orderDetails = {},
    isLoggedIn = false
  } = props;

  if (
    isFetchingOrderDetails ||
    isSubmittingReplaceSim ||
    (!isLoggedIn && isEmpty(orderDetails))
  )
    return <Spinner size={200} sx={styles.fullPage} />;

  return <ReportFraud {...props}></ReportFraud>;
};

const mapStateToProps = createStructuredSelector({
  orderRef: makeSelectGuestOrderOrderRef(),
  orderDetails: makeSelectOrderDetails(),
  inProgressReplaceSim: makeSelectInProgressReplaceSim(),
  isFetchingOrderDetails: makeSelectIsFetchingData("orderDetails"),
  isSubmittingReplaceSim: makeSelectIsFetchingData("submitReplaceSim")
});

export const mapDispatchToProps = dispatch => {
  return {
    fetchOrderDetails: orderRef => {
      const params = {
        type: ORDER_ACTION_TYPES.REPORT_FRAUD,
        order_ref: orderRef
      };

      dispatch(fetchOrderDetails(params));
    }
  };
};

ReportFraudAction.defaultProps = {
  fetchOrderDetails: () => {}
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect, memo)(ReportFraudAction);
